// Small brand pill shown next to a nav item name (e.g. "New").
// Used by both the desktop mega menu (NavServicesMega) and the mobile menu.
export function NavBadge({ label }: { label: string }) {
  return (
    <span className="inline-flex items-center rounded-full border border-[#B7DED9] bg-[#E8F4F2] px-2 py-[3px] text-[10px] font-bold uppercase leading-none tracking-[0.08em] text-[#157A73]">
      {label}
    </span>
  );
}
